import { Autocomplete, Checkbox, FormControl, MenuItem, Select, TextField } from "@mui/material";
import { DatePicker, MobileTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Modal, } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useFetchCreateRemainderMutation, useFetchTaskRemainderUsersQuery } from "../../../slice/logdetailSlice";
import { toast } from "react-toastify";
import { deleteCommentEntities } from "../../../apis/apiService";


const TaskRemainderPopup = ({ disabled, id, remainderList, refetch }) => {
  const {
    handleSubmit,
    watch,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [showPopup, setShowPopup] = useState(false);
  const [formattedUsers, setFormattedUsers] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const { data: getRemainderUsers = [], refetch: remainder_users_refetch } = useFetchTaskRemainderUsersQuery({ type: "task", id: id });
  const [createRemainder, { isLoading }] = useFetchCreateRemainderMutation();
  const [loading, setLoading] = useState(false);


  const taskUsers = [
    { name: "Project Owner", value: "project_owner" },
    { name: "Task Owner", value: "task_owners" },
    { name: "Task Created By", value: "task_created_by" },
    { name: "Task Followers", value: "task_followers" },
    { name: "Project Users", value: "project_users" },
  ];

  const formatUserDatas = (projectUsers, taskUsers) => {
    const formatted = [];

    // Add Task Users title
    formatted.push({ type: "title", label: "Task Users" });

    // Add all task users
    formatted.push(
      ...(taskUsers || []).map((user) => ({
        ...user,
        user_id: user.value,
        name: user.name,
        type: "task_user",
      }))
    );

    // Add Project Users title
    formatted.push({ type: "title", label: "Project Users" });

    // Add all project users
    formatted.push(
      ...(projectUsers || []).map((user) => ({
        ...user,
        type: "project_user",
      }))
    );

    return formatted;
  };

  const getDefaultReminderValues = () => ({
    reminder_type: "daily",
    date_type: "none",
    day: "1",
    reminder_time: dayjs().hour(9).minute(0),
    reminder_date: dayjs().add(1, "day"),
    notify_group: [],
    notify_users: [],
  });

  useEffect(() => {
    if (remainderList) {
      // console.log(
      //   "getRemainderUsers date type format :",
      //   remainderList.date_type
      // );
      reset({
        reminder_type: remainderList.reminder_type,
        date_type: remainderList.date_type,
        day: remainderList.days,
        // days: "",
        // date_type: "",
        reminder_time: remainderList.reminder_time
          ? dayjs(`1970-01-01T${remainderList.reminder_time}`)
          : dayjs().hour(9).minute(0),

        reminder_date: remainderList.reminder_date
          ? dayjs(remainderList.reminder_date)
          : dayjs().add(1, "day"),
        notify_group: remainderList.notify_group || [],
        notify_users: remainderList.notify_users || [],
      });
      const formattedTime = remainderList.reminder_time
        ? dayjs(`1970-01-01T${remainderList.reminder_time}`).format("hh:mm A")
        : "";

      const label = `${remainderList.reminder_type}${
        remainderList.reminder_date ? ` - ${remainderList.reminder_date}` : ""
      } - ${formattedTime}`;
      setSelectedValue(label);
      // refetch();
    } 
    else {
      // Reset for "Add" flow
      reset(getDefaultReminderValues);
      setSelectedValue("");
    }
  }, [remainderList, reset, showPopup]);

  useEffect(() => {
    const combined = formatUserDatas(getRemainderUsers, taskUsers);
    setFormattedUsers(combined);
  }, [getRemainderUsers]);
  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    setShowPopup(true);
  };

  const handleOpen = () => {
    setShowPopup(true);
  };

  const handleclose = () => {
    setShowPopup(false);
    reset();
  };

  const remainderTaskWatch = watch("reminder_type");
  const remainderTypeWatch = watch("date_type");
  //   const handleRemainder = (data) => {
  //     // alert("Submitted!");
  //     setSelectedValue(
  //       data.reminder_type,
  //       dayjs(data.reminder_date).format("DD/MM/YYYY"),
  //       data.reminder_time
  //     );
  //   };

  const handleRemainder = async (data) => {
    const formattedTime = dayjs(data.reminder_time).format("HH:mm"); // 24hr format
    dayjs(data.reminder_time).format("HH:mm A"); // 24hr format
    const formattedDate =
      data.reminder_type === "on" && data.date_type === "specific_date" ? dayjs(data.reminder_date).format("YYYY-MM-DD") : null;

    const requestedData = {
      reminder_type: data.reminder_type,
      date_type: data.date_type === "none" ? null : data.date_type,
      model_id: id,
      model_type: "task",
      reminder_time: formattedTime,
      reminder_date: formattedDate,
      days: data.day,
      notify_group: data.notify_group,
      notify_users: data.notify_users,
    };

    try {
      const response = await createRemainder({
        url: remainderList
          ? `task/reminder/update/${remainderList?.reminder_id}`
          : `task/reminder`,
        data: requestedData,
      }).unwrap();

      if (response) {
        // setSelectedValue(label);
        toast.success(response?.data?.message || response.message);
        setShowPopup(false);
        refetch();
        // console.log("remainder update response :", response);
      }
    } 
    catch (error) {
      // console.log("remainder error response :", error);
      toast.error(
        error?.data?.message || error.message || "Something went wrong"
      );
      // console.error(error);
    }
  };

  const handleDeleteRemainder = async () => {
    setLoading(true);
    try {
      const response = await deleteCommentEntities( "task/reminder/delete", remainderList?.reminder_id);
      toast.success(response?.data?.message || response.message);
      setSelectedValue("");
      // console.log("remainder delete response :", response);
      reset(getDefaultReminderValues);
      refetch();
      setShowPopup(false);
    } 
    catch (err) {
      toast.error(err?.data?.message || err.message);
      // console.log("remainder delete error response :", error);
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (remainderTaskWatch === "daily") {
      setValue("date_type", "none");
    } 
    else if (remainderList === null && remainderTaskWatch === "on") {
      setValue("date_type", "specific_date");
    } 
    else if (
      remainderTaskWatch === "before" ||
      remainderTaskWatch === "after") 
    {
      setValue("day", "1");
      // setValue("days", "days");
      setValue("date_type", "start_date");
    }
  }, [setValue, remainderTaskWatch, showPopup]);
  
  return (
    <>
      {/* <FormControl fullWidth>
        <Select
          value={selectedValue}
          onOpen={handleOpen}
          // onClose={handleclose}
          // onBlur={(e) => handleBlur(e, nameChange.task_id)}
          // name="reminder_type"
        />
      </FormControl> */}
      <FormControl fullWidth>
        <TextField
          disabled={disabled}
          value={selectedValue || "Set Reminder"}
          onClick={handleOpen}
          InputProps={{
            readOnly: true,
          }}
        />
      </FormControl>

      <Modal show={showPopup} onHide={handleclose}>
        <form action="" onSubmit={handleSubmit(handleRemainder)}>
          <Modal.Header closeButton>
            <Modal.Title>Set Task Reminder</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              <div className="row mb-3">
                <label className="form-label">
                  Reminder Type <span className=" errorMsg">*</span>
                </label>

                <div className="col-md-6 mb-3">
                  <Controller
                    name="reminder_type"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select {...field}>
                          <MenuItem value="daily">Daily</MenuItem>
                          <MenuItem value="on">On</MenuItem>
                          <MenuItem value="before">Before</MenuItem>
                          <MenuItem value="after">After</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  {/* {(remainderTaskWatch === "daily" ||
                    remainderTaskWatch === "on") && ( */}
                  <Controller
                    name="date_type"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        {remainderTaskWatch === "daily" && (
                          <Select defaultValue="none" {...field} displayEmpty>
                            <MenuItem value="none" disabled>
                              NA
                            </MenuItem>
                          </Select>
                        )}
                        {remainderTaskWatch === "on" && (
                          <Select {...field} displayEmpty>
                            <MenuItem value="specific_date">
                              Specific Date
                            </MenuItem>
                            <MenuItem value="created_date">
                              Created Date
                            </MenuItem>
                            <MenuItem value="start_date">Start Date</MenuItem>
                            <MenuItem value="due_date">Due Date</MenuItem>
                            <MenuItem value="completionDate">
                              Completion Date
                            </MenuItem>
                          </Select>
                        )}
                        {(remainderTaskWatch === "before" ||
                          remainderTaskWatch === "after") && (
                          <Select {...field}>
                            <MenuItem value="start_date">Start Date</MenuItem>
                            <MenuItem value="due_date">Due Date</MenuItem>
                          </Select>
                        )}
                      </FormControl>
                    )}
                  />
                  {/* )} */}
                </div>
              </div>

              {(remainderTaskWatch === "before" ||
                remainderTaskWatch === "after") && (
                <div className="row mb-3">
                  <div className="col-md-6">
                    <Controller
                      name="day"
                      control={control}
                      render={({ field }) => <TextField {...field} fullWidth />}
                    />
                  </div>
                  <div className="col-md-6">
                    {/* <Controller
                      name="days"
                      control={control}
                      render={({ field }) => ( */}
                    <FormControl fullWidth>
                      <Select defaultValue="days">
                        <MenuItem value="days">Days</MenuItem>
                      </Select>
                    </FormControl>
                    {/* )} 
                    /> */}
                  </div>

                  {/* <div className="col-md-4">
                    <Controller
                      name="date_type"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth>
                         
                        </FormControl>
                      )}
                    />
                  </div> */}
                </div>
              )}

              {remainderTaskWatch === "on" &&
                remainderTypeWatch === "specific_date" && (
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="">
                        Date <span className=" errorMsg">*</span>
                      </label>
                      <div>
                        <Controller
                          name="reminder_date"
                          control={control}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              //   value={value}
                              onChange={(newValue) => {
                                field.onChange(newValue);
                                // setValue(newValue);
                              }}
                              slotProps={{ textField: { fullWidth: true } }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}
              {/* 
              {(remainderTaskWatch !== "on" ||
                (remainderTaskWatch === "on" &&
                  remainderTypeWatch !== "specific_date")) && ( */}

              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="">
                    Time <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="reminder_time"
                    control={control}
                    render={({ field }) => (
                      <MobileTimePicker
                        {...field}
                        //   value={timerValue}
                        onChange={(newValue) => {
                          field.onChange(newValue);
                          // setTimerValue(newValue);
                        }}
                        disabled
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    )}
                  />
                </div>
              </div>

              {/* )} */}
              {/* <div className="col-md-12 mb-3">
                <label htmlFor="project_manager_id" className="form-label">
                  Owner
                </label>
                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={formattedUsers}
                    getOptionLabel={(option) =>
                      option.name || option.label || ""
                    }
                    filterSelectedOptions
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) =>
                      option.user_id === value.user_id
                    }
                    getOptionDisabled={(option) => option.type === "title"}
                    value={formattedUsers.filter((user) =>
                      watch("owners")?.includes(user.user_id)
                    )}
                    onChange={(event, newValue) => {
                      const selectableUsers = newValue.filter(
                        (user) => user.type !== "title"
                      );
                      const selectedIds = selectableUsers.map(
                        (user) => user.user_id
                      );
                      setValue("owners", selectedIds);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" />
                    )}
                    renderOption={(props, option, { selected }) => {
                      if (option.type === "title") {
                        return (
                          <li
                            {...props}
                            style={{
                              fontWeight: "bold",
                              pointerEvents: "none",
                              opacity: 0.7,
                              width: "100%", // Ensure full width
                              backgroundColor: "#f4f4f4", // Optional highlight
                              padding: "8px",
                            }}
                          >
                            {option.label}
                          </li>
                        );
                      }

                      return (
                        <li
                          {...props}
                          className="d-flex align-items-center mb-2"
                        >
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          <strong>{option.name}</strong>
                        </li>
                      );
                    }}
                    ListboxProps={{
                      style: {
                        display: "block",
                        paddingLeft: "0",
                      },
                    }}
                  />
                </FormControl>
              </div> */}

              <div className="col-md-12 mb-3">
                <label htmlFor="taskUsers" className="form-label">
                  Task Users <span className=" errorMsg">*</span>
                </label>
                <Controller
                  name="notify_group"
                  control={control}
                  rules={{ required: " Users field is required" }}
                  render={({ field: { onChange, value } }) => {
                    // Filter options to exclude already selected values
                    const selectedValues = value || [];
                    const availableOptions = taskUsers.filter(
                      (option) => !selectedValues.includes(option.value)
                    );

                    return (
                      <Autocomplete
                        multiple
                        options={availableOptions}
                        getOptionLabel={(option) => option.name}
                        value={taskUsers.filter((user) =>
                          selectedValues.includes(user.value)
                        )}
                        disableCloseOnSelect
                        onChange={(event, newValue) => {
                          onChange(newValue.map((val) => val.value));
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.name}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              value && value.length > 0 ? "" : "Select Users"
                            }
                          />
                        )}
                      />
                    );
                  }}
                />

                {errors?.notify_group && (
                  <span className="errorMsg">
                    {errors.notify_group.message}
                  </span>
                )}
              </div>

              <div className="col-md-12 mb-3">
                <label htmlFor="">Project Users</label>
                <Controller
                  name="notify_users"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    const selectedIds = value || [];
                    const availableOptions = getRemainderUsers.filter(
                      (user) => !selectedIds.includes(user.user_id)
                    );

                    return (
                      <Autocomplete
                        multiple
                        options={availableOptions}
                        getOptionLabel={(option) => option.name}
                        disableCloseOnSelect
                        value={getRemainderUsers.filter((user) =>
                          selectedIds.includes(user.user_id)
                        )}
                        onChange={(event, newValue) => {
                          onChange(newValue.map((user) => user.user_id));
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.name}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              value && value.length > 0 ? "" : "Select Users"
                            }
                          />
                        )}
                      />
                    );
                  }}
                />
              </div>
            </div>
          </Modal.Body>
          
          <Modal.Footer>
            {!remainderList && (
              <button
                className=" addmore_btn"
                disabled={isLoading}
                type="submit"
              >
                Save
              </button>
            )}
            {remainderList && (
              <button
                className=" addmore_btn"
                disabled={isLoading}
                type="submit"
              >
                Update
              </button>
            )}
            {remainderList && (
              <button
                className=" cancel_btn"
                onClick={handleDeleteRemainder}
                type="button"
                disabled={loading}
              >
                Delete
              </button>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default TaskRemainderPopup;
